import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/banyan/src/Pebbles/select';
import {
  getTranslatedText,
  useIntl,
  withErrorBoundary
} from '@nile/components';
import { useStateList } from '@nile/components/src/Constants/stateslist/getstates';
import { isEmpty } from 'lodash';

function StateListDropDown(props) {
  const {
    stateCode,
    countryCode,
    placeholderkey,
    labelkey,
    handleFunction
  } = props;

  const converToDropdownStructure = (data) => {
    return data
      .map((item) => ({
        ...item,
        value: item.isoCode,
        label: item.name
      }))
      .sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });
  };
  const intl = useIntl();
  const states = useStateList('states');
  const [statesList, setStatesList] = useState([]);
  const [currentSelectedState, setCurrentSelectedState] = useState(
    !isEmpty(stateCode)
      ? {
          label: stateCode,
          value: stateCode,
          isoCode: stateCode
        }
      : null
  );

  const onDropdownChange = (state) => {
    setCurrentSelectedState(state);
    handleFunction(...props.handleFunctionArgs, state?.isoCode || null);
  };
  const countriesStates = (country) => {
    return country ? states.filter((st) => st.countryCode === country) : [];
  };
  useEffect(() => {
    const structuredStates = converToDropdownStructure(
      countriesStates(countryCode)
    );
    setCurrentSelectedState(null);
    setStatesList(structuredStates);
  }, [states, countryCode]);

  useEffect(() => {
    const selectedState = states.find(
      (st) => st?.isoCode === stateCode && st?.countryCode === countryCode
    );
    if (selectedState) {
      const currentState = converToDropdownStructure(
        selectedState ? [selectedState] : []
      );
      setCurrentSelectedState(currentState);
    }
  }, [states, stateCode]);

  return (
    <div>
      <Select
        value={currentSelectedState}
        label={getTranslatedText(intl, labelkey)}
        options={statesList}
        onChange={onDropdownChange}
        components={{ IndicatorSeparator, DropdownIndicator }}
        classNamePrefix="value_selector"
        formatGroupLabel={formatGroupLabel}
        menuPlacement="auto"
        placeholder={getTranslatedText(intl, placeholderkey)}
        menuPortalTarget={document.body}
        isClearable
        closeMenuOnScroll={(e) => {
          return (
            e.target &&
            e.target.classList &&
            !(e.target.classList.value.indexOf('menu-list') > -1)
          );
        }}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 })
        }}
      />
    </div>
  );
}
export default StateListDropDown;
